import { FC, useRef, useState } from "react";
import cx from "classnames";
import { QESButton } from "@app/shared/qes-standards/Button";
import Modal from "@app/shared/Modals/Modal";
import { ModalLinkProps } from "@app/shared/Modals/modalProps";

/**
 * An unstyled button component that, on click, opens a modal defined in the props.<br />
 * Modals are preferred over Flyouts when all you need is a simple "yes/no" prompt for the user.
 */
const ModalLink: FC<ModalLinkProps> = (props: ModalLinkProps) => {
  const [isVisible, setIsVisible] = useState(false);
  const modalTrigger = useRef<HTMLButtonElement>(null);
  const { children, classNames, disabled, testId, content, onClose, ...modalProps } = props;

  const handleClose = () => {
    if (!!onClose) {
      onClose();
    }
    setIsVisible(false);
  };

  return (
    <>
      <QESButton
        qesType="none"
        className={cx({
          [classNames]: !!classNames,
          "new-modal-link": true,
        })}
        disabled={disabled}
        onClick={() => setIsVisible(true)}
        qesTestId={testId}
        qesRef={modalTrigger}
      >
        {children}
      </QESButton>
      <Modal
        closeModal={handleClose}
        isVisible={isVisible}
        content={{
          ...content,
          confirmButtonAction: () => { content.confirmButtonAction(); setIsVisible(false); }
        }}
        triggerElement={modalTrigger}
        {...modalProps}
      />
    </>
  );
}

export default ModalLink;
